import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control, Lookup } from "projects/sepidz-web-framework/src/lib/models";
import { GridColumnInfoDetail } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { LookupService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { find, take, takeUntil } from "rxjs/operators";
import { GoodsGroup } from "../../models/goods-group.model";
import { Goods } from "../../models/goods.model";
import { Unit } from "../../models/unit.model";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";

@Component({
  selector: "goods-import-excel-form",
  templateUrl: "./goods-import-excel-form.component.html",
  styleUrls: ["./goods-import-excel-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoodsImportExcelFormComponent extends BaseFormComponent<Goods> {
  gridInfo: GridColumnInfoDetail[];
  goodsList: Goods[] = [];
  goodsGroupList: GoodsGroup[];
  goodsUnitList: Unit[];
  hColumns: form_control[] = [];
  goodsKindList: Lookup[];

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, private lookupservice: LookupService) {
    super(selectorService, cd);
  }

  async ngOnInit(): Promise<void> {
    this.apiName = "Goods";
    this.label = "دریافت فایل اکسل";
    super.ngOnInit();
    await this.setData();
  }

  async setColumns(): Promise<void> {
    await super.setColumns();
    this.hColumns = [];
    this.hColumns.push(<form_control>{
      label: "ردیف اول عنون ستونهاست.",
      controlType: FormControlTypes.checkbox,
      modelName: "isFirstRowColumnsName",
      disabled: false,
      name: "isFirstRowColumnsName",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: true,
    });
  }

  addControl(): void {
    this.setValue("isFirstRowColumnsName", true);
  }

  async onFileChange(evt: any) {
    const target: DataTransfer = <DataTransfer>evt.target;
    if (target.files.length > 1) {
      this.sts.showDialog("انتخاب بیش از یک فایل مجاز نیست.", "");
      return;
    } else {
      const result = await this.parseExcelDoc(target.files[0]).catch((err) => console.error(err));
      this.SetGoodsInfo(result);
    }
  }

  async setData() {
    await this.httpCommonService
      .getList("Unit")
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data) => {
          if (data) this.goodsUnitList = data as Unit[];
        },
        (error) => this.getFailedHelper(error)
      );

    await this.httpCommonService
      .getList("GoodsGroup")
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data) => {
          if (data) this.goodsGroupList = data as GoodsGroup[];
        },
        (error) => this.getFailedHelper(error)
      );

    await this.lookupservice
      .getLookupbyCategory("INV", "GoodsKind")
      .pipe(take(1))
      .toPromise()
      .then((data) => {
        if (data) this.goodsKindList = data;
      });
  }

  SetGoodsInfo(excelData: any[]) {
    let ColumnsName = [];
    let errorMessage: string = "";
    let isFirst = this.formGroup.get("isFirstRowColumnsName")?.value;

    if (isFirst) ColumnsName = excelData[0] as any[];
    else ColumnsName = this.gridInfo.filter((c) => c.name != null && c.title != "عملیات" && !c.hidden) as any[];

    for (let index = 0; index < excelData.filter((x) => x.length).length; index++) {
      let excelRow = excelData[index];
      if (index !== 0) {
        let entity: Goods = <Goods>{};
        entity.IsGoods = true;
        let index: number = 0;
        ColumnsName.forEach((c) => {
          let key: string;
          if (c.name) key = c.name;
          else {
            const colName = this.orignalColumns.find((g) => g.label === c || g.name == c);
            if (colName) key = colName.name;
          }
          entity[key] = excelRow[index];

          switch (key) {
            case "Code":
              if (typeof entity.Code !== "string") entity.Code = `${entity.Code}`;
              break;

            case "GoodsKindCode":
            case "GoodsKindTitle":
              const goodsKind = this.goodsKindList.find((x) => x.Code == entity.GoodsKindCode || x.Title == entity.GoodsKindTitle);
              entity.GoodsKindId = goodsKind?.Id;
              if (!entity.GoodsKindId) {
                (errorMessage += `برای کالای ${entity.Title} نوع کالای' ${entity.GoodsKindCode} پیدا نشد.`), "دریافت کالا" + ",";
              }
              break;

            case "GoodsGroupTreeCode":
              const goodsGroup = this.goodsGroupList.find((gg) => gg.TreeCode === entity.GoodsGroupTreeCode || gg.Code === entity.GoodsGroupTreeCode);
              entity.GoodsGroupId = goodsGroup?.Id;
              if (!entity.GoodsGroupId)
                (errorMessage += `برای کالای ${entity.Title} گروه کالای' ${entity.GoodsGroupTreeCode} پیدا نشد.`), "دریافت کالا" + ",";
              break;

            case "UnitCode":
            case "UnitId":
              const goodsUnit = this.goodsUnitList.find((u) => u.Code === Number(entity.UnitCode) || u.Title === String(entity.UnitId));
              entity.UnitId = goodsUnit?.Id;
              if (!entity.UnitId) (errorMessage += `برای کالای ${entity.Title} واحد سنجش ${entity.UnitCode} پیدا نشد.`), "دریافت کالا" + ",";
              break;
            case "DefaultUnitCode":
            case "DefaultUnitTitle":
              const defaultUnit = this.goodsUnitList.find(
                (u) => u.Code === Number(entity.DefaultUnitCode) || u.Title === String(entity.DefaultUnitTitle)
              );
              entity.DefaultUnitId = defaultUnit?.Id;
              if (!entity.DefaultUnitId)
                (errorMessage += `برای کالای ${entity.Title} واحد سنجش پیشفرض ${entity.UnitCode} پیدا نشد.`), "دریافت کالا" + ",";

              break;
          }

          index++;
        });

        if (entity.DefaultUnitRatio > 1) {
          entity.GoodsUnits = [];
          entity.GoodsUnits.push({
            UnitId: entity.DefaultUnitId,
            State: RowState.New,
            IsDefault: true,
            Ratio: entity.DefaultUnitRatio,
            UnitTitle: entity.DefaultUnitTitle,
            GoodsId: 0,
            CreatedDate: new Date(),
            Id: 0,
          });
        } else entity.DefaultUnitId = entity.UnitId;

        const notExistBefore = !this.goodsList.some((g) => g.Code?.trim() === entity.Code?.trim() || g.Title?.trim() === entity.Title?.trim());
        if (notExistBefore && entity.UnitId > 0 && entity.GoodsKindId > 0) this.goodsList.push(entity);
        else console.log(entity);
      }
      if (errorMessage) break;
    }
    if (!errorMessage) {
      this.httpCommonService
        .bulkInsert(this.apiName, this.goodsList)
        .pipe(take(1))
        .subscribe(
          (results) => {
            this.sts.showToast("success", "", "اطلاعات با موفیت ذخیره شد.");
            this.close();
          },
          (error) => {
            this.close();
            this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در ذخیره اطلاعات");
          }
        );
    } else this.sts.showDialog(errorMessage, "خطا در دریافت کالا");
  }

  public cancel() {
    this.close();
  }
}
